import { redirect } from "react-router";

export function rootLoader({ request }: { request: Request }) {
  const url = new URL(request.url);
  const hasVisited = localStorage.getItem("has-visited");
  const hasOidcSession = Object.keys(localStorage).some((k) => k.startsWith("oidc."));
  // autologin=1 is set by Zitadel's post-invite default redirect URI; it must
  // reach the authenticated shell so UserProvider starts the OIDC login
  // immediately instead of parking new invitees on the welcome page.
  const isAutoLogin = url.searchParams.get("autologin") === "1";
  if (url.pathname === "/" && !isAutoLogin && !hasVisited && !hasOidcSession) {
    return redirect("/welcome");
  }
  return null;
}
